class RitualProductDelivery extends HTMLElement {
  connectedCallback() {
    const target = this.querySelector('[data-rxp-delivery-date]');
    if (!target) return;
    const date = new Date();
    let days = Math.max(0, Math.floor(Number(this.dataset.days || 0)));
    while (days > 0) {
      date.setDate(date.getDate() + 1);
      if (this.dataset.skipWeekends === 'true' && [0, 6].includes(date.getDay())) continue;
      days -= 1;
    }
    const locale = document.documentElement.lang || navigator.language || 'en';
    const weekdays = (this.dataset.weekdays || '').split(',').map(value => value.trim());
    const months = (this.dataset.months || '').split(',').map(value => value.trim());
    const weekday = weekdays.length === 7 && weekdays.every(Boolean) ? weekdays[date.getDay()] : new Intl.DateTimeFormat(locale, { weekday: 'short' }).format(date);
    const month = months.length === 12 && months.every(Boolean) ? months[date.getMonth()] : new Intl.DateTimeFormat(locale, { month: 'long' }).format(date);
    const day = date.getDate();
    const iso = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    const formats = {
      weekday_month_day: `${weekday}, ${month} ${day}`,
      weekday_day_month: `${weekday}, ${day} ${month}`,
      day_month: `${day} ${month}`,
      month_day: `${month} ${day}`,
      iso,
    };
    target.textContent = formats[this.dataset.dateFormat] || formats.weekday_month_day;
    target.setAttribute('datetime', iso);
  }
}
if (!customElements.get('ritual-product-delivery')) customElements.define('ritual-product-delivery', RitualProductDelivery);
